export default __webpack_public_path__ + "assets/fog-day.8642a433.svg";